module.exports = __webpack_public_path__ + "img/ejymjpg.8a62a45b.jpg";